import { CircleSpinner } from 'react-spinners-kit'
import './UsageCard.css'

function UsageCard ({
  title,
  value,
  total,
  icon,
  color,
  isLoadingStates,
  isLoadingPercentage,
  isIncreasing,
  percentage = null
}) {
  function getPercentage () {
    return Math.round(parseInt((value / total) * 100))
  }

  function renderTrend () {
    if (isLoadingPercentage || percentage === null) return null
    if (percentage === 0) return <p className='no-percentage'>-</p>
    const safe = isNaN(percentage) || !isFinite(percentage) ? 0 : percentage
    return (
      <>
        <p className='trend-icon-stats'>
          <i className={'fas ' + (isIncreasing ? 'fa-arrow-up' : 'fa-arrow-down')} />
        </p>
        <span className={`trend-text-stats ${isIncreasing ? 'increasing-stats' : 'decreasing-stats'}`}>
          {Math.round(Math.abs(safe))}%
        </span>
      </>
    )
  }

  return (
    <div className='col-md-3 usage-card-col'>
      <div className={`usage-card ${color ? color + '-card' : ''}`}>
        {isLoadingStates
          ? (
            <div className='loaderDiv'>
              <CircleSpinner size={20} color='#304044' className='loader' />
            </div>
            )
          : (
            <>
              <div className='usage-card-header'>
                <h5 className='dark-txt usage-card-title' title={title}>{title}</h5>
                {icon && <i className={'fas usage-card-icon ' + icon} />}
              </div>
              <div className='usage-card-body'>
                <h3 className={(color && color !== 'total') ? 'dark-txt' : undefined}>{value}</h3>
                {total && <p className='dark-txt usage-card-share'>{getPercentage() + '%'}</p>}
              </div>
              {/* Always rendered, empty or not, so every card has the same height. */}
              <div className='card-footer-stats'>{renderTrend()}</div>
            </>
            )}
      </div>
    </div>
  )
}

export default UsageCard
